// extracted by mini-css-extract-plugin
export default {"wrapper":"MicrogridConfigure_wrapper__kjq1m"};